//@flow
import type { PermissionResult } from 'core/service/distributor/permission'
import type { AppState } from 'quick-quote/reducers'

export const getProceedToInvestmentProduct = (state: AppState): PermissionResult =>
  state.investment.proceedToInvestmentProduct
